import { Box, Stack, Typography } from "@mui/material"
import BlockIcon from '@mui/icons-material/Block';
export default function AvisoNoRegistraInscripciones() {
    return (
        <Box
            sx={{
                minHeight: "80vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
            }}
        >
            <Stack spacing={3} alignItems="center" sx={{ maxWidth: 420 }}>
                <BlockIcon sx={{fontSize:90}} />
                <Box sx={{ textAlign: "center" }}>
                    <Typography
                        variant="h6"
                        component="h2"
                        sx={{
                            fontWeight: 700,
                            color: "#4a4a4f",
                            mb: 1,
                            letterSpacing: 0.2,
                        }}
                    >
                        No se puede realizar esta acción.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "#8a8a90",
                            lineHeight: 1.6,
                        }}
                    >
                        El [convenio/situación frente a ingresos brutos] que tiene registrado el cliente NO admite la carga
                        de inscripciones.
                    </Typography>
                </Box>
            </Stack>
        </Box>
    )
}
